import AiUsageComponent from '../AiUsageComponent.vue'
import AiCostCenterComponent from '../AiCostCenterComponent.vue'
import { AGENT_SETTINGS_ADMIN_EMAILS } from '../../agent-time-tracking/agentSettingsAccess'

export default [
    {
        // DGTasks' own AI usage detail (call log, export). Same people as Agent Settings
        // (AiUsageController enforces it server-side).
        path: '/ai-usage',
        name: 'AiUsage',
        meta: { layout: 'default', allowedEmails: AGENT_SETTINGS_ADMIN_EMAILS },
        component: AiUsageComponent,
    },
    {
        // AI Cost and Usage: all three apps (DGTasks, PlanMyTour, GoGroupBooking).
        // Admins and Super Admins; AiCostCenterController enforces the same.
        path: '/ai-cost',
        name: 'AiCost',
        meta: { layout: 'default', requiresRole: [1, 11] },
        component: AiCostCenterComponent,
    },
]
